// extracted by mini-css-extract-plugin
export default {"description":"W4vaQ7ANqIRtiE1VodTf"};